/**
 * Returns just an AMI ID
 */
export type AmiContextResponse = string;
